import React from 'react';
import root from 'window-or-global';
import {NavLink} from 'react-router-dom';
import styles from './SignUpSuccessSection.pcss';
import {Button, Message, getMessage} from 'epic-diesel-common';
import {priority} from 'epic-diesel-common/src/constants';
import {generateRoutePath} from 'epic-common/src/route';
import PropTypes from 'prop-types';

export default class SignUpSuccessSection extends React.Component {
    static propTypes = {
        messages: PropTypes.object,
        confirmationCode: PropTypes.string
    };

    static defaultProps = {};
    componentDidMount() {
        // a quick hack to fire a success pageView pixel without breaking too many things
        if (root.history && typeof root.history.pushState) {
            root.history.pushState(null, '', generateRoutePath('/signup/success'));
        }
    }
    render() {
        const {confirmationCode, messages} = this.props;
        const signupSuccessText = getMessage(messages, 'epic.affiliate.signup.success.text');

        return (
            <div className={styles.container}>
                <div className={styles.emailInfo}>
                    <div className={styles.emailInfoDetail}>
                        <h2>
                            <Message
                                code="epic.affiliate.signup.success.header"
                                className={styles.title}
                                args={[confirmationCode]}
                            />
                        </h2>
                        <div className={styles.emailInfoDescription}>
                            <span dangerouslySetInnerHTML={{__html: signupSuccessText}} />
                        </div>
                        <div className={styles.emailAccountInfoItem}>
                            <NavLink
                                activeClassName={styles.active}
                                to={generateRoutePath('overview')}>
                                <Button priority={priority.PRIMARY} theme="dark">
                                    <Message code="epic.affiliate.common.ok" />
                                </Button>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
